import { useState } from "react";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function DatePicker({ value, onChange, testid = "date-picker" }) {
  const [open, setOpen] = useState(false);
  const sel = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="h-10 w-full flex items-center gap-2 rounded-md border border-input bg-background px-3 text-sm text-left transition-colors hover:border-[#C2A462]/60">
          <CalendarIcon className="h-4 w-4 text-[#C2A462]" />
          <span className={sel ? "" : "text-muted-foreground"}>{sel ? sel.toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "long", year: "numeric" }) : "Pick a date"}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 border-[#C2A462]/40" align="start" data-testid={`${testid}-calendar`}>
        <Calendar mode="single" selected={sel} defaultMonth={sel} weekStartsOn={1} onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
